var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.showDrawer)?_c('my-drawer',{model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}}):_vm._e(),_c('v-main',[(_vm.showDrawer)?_c('my-navbar',{on:{"toggleDrawer":_vm.toggleDrawer}}):_vm._e(),_c('router-view')],1),(_vm.showFooter)?_c('close-app-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }